<script>
    // ═══ РЕДАКТОР ХУДА (открывается командой админа 9 уровня) ═══
    // Мышь — перетаскивание блока, колесо мыши или уголок блока — размер,
    // стрелки — точная подгонка (Shift = крупный шаг), поля X/Y/масштаб —
    // ручной ввод, направляющие с линейками — как в фотошопе.
    // Саму панель можно перетащить за заголовок, место запоминается.
    // «Применить всем» шлёт раскладку на сервер: он сохраняет её в файл и
    // раздаёт всем игрокам онлайн.
    import { executeClient } from 'api/rage'
    import {
        HUD_PARTS, hudLayout, hudEditMode, hudEditSelected,
        ANCHOR_NAME, applyPatch, resetLayout, scaleBy, clampScale,
        SCALE_MIN, SCALE_MAX, mapRect,
    } from 'store/hudlayout'

    let saved = '';
    let showGuides = true;

    $: sel = $hudEditSelected;
    $: part = $hudLayout[sel];

    const num = (v, d = 0) => Math.round((Number(v) || 0) * 10 ** d) / 10 ** d;

    const nudge = (dx, dy, big) => {
        const step = big ? 1 : 0.1;
        applyPatch(sel, {
            x: num(part.x + dx * step, 1),
            y: num(part.y + dy * step, 1),
        });
    };

    const onKey = (e) => {
        if (!$hudEditMode) return;
        const tag = (e.target && e.target.tagName) || '';
        if (tag === 'INPUT' || tag === 'SELECT') return;
        const big = e.shiftKey;
        if (e.key === 'ArrowLeft')  { e.preventDefault(); nudge(-1, 0, big); }
        if (e.key === 'ArrowRight') { e.preventDefault(); nudge(1, 0, big); }
        if (e.key === 'ArrowUp')    { e.preventDefault(); nudge(0, -1, big); }
        if (e.key === 'ArrowDown')  { e.preventDefault(); nudge(0, 1, big); }
        if (e.key === '+' || e.key === '=') { e.preventDefault(); scaleBy(sel, big ? 0.2 : 0.05); }
        if (e.key === '-' || e.key === '_') { e.preventDefault(); scaleBy(sel, big ? -0.2 : -0.05); }
        if (e.key === 'Escape')     { e.preventDefault(); close(); }
    };

    // ── привязка к миникарте: блок начинает жить в её системе координат и
    // едет вместе с ней, когда карта меняет размер. Координаты пересчитываем,
    // чтобы в момент переключения блок остался ровно там же, где стоял.
    const togglePin = (on) => {
        const r = $mapRect;
        if (on && (!r || !r.ok || r.w <= 0 || r.h <= 0)) {
            saved = 'Миникарты сейчас не видно — привязывать не к чему';
            setTimeout(() => (saved = ''), 3000);
            return;
        }
        if (on) {
            const lx = part.x / 100 * window.innerWidth;
            const ly = part.y / 100 * window.innerHeight;
            applyPatch(sel, {
                pin: 'map',
                x: num((lx - r.x) / r.w * 100, 1),
                y: num((ly - r.y) / r.h * 100, 1),
            });
        } else {
            const lx = (r && r.ok) ? r.x + part.x / 100 * r.w : part.x / 100 * window.innerWidth;
            const ly = (r && r.ok) ? r.y + part.y / 100 * r.h : part.y / 100 * window.innerHeight;
            applyPatch(sel, {
                pin: 'screen',
                x: num(lx / window.innerWidth * 100, 1),
                y: num(ly / window.innerHeight * 100, 1),
            });
        }
    };

    // Готовые положения — чтобы поставить блок в угол/центр одним щелчком
    const putTo = (anchor, x, y) => applyPatch(sel, { anchor, x, y });

    const save = () => {
        try {
            executeClient('hud.layout.save', JSON.stringify($hudLayout));
            saved = 'Раскладка применена всем игрокам и сохранена';
            setTimeout(() => (saved = ''), 3000);
        } catch (e) { saved = 'Не удалось отправить на сервер'; }
    };

    const reset = () => { resetLayout(); saved = 'Возвращена стандартная раскладка (не забудь применить)'; };

    const close = () => {
        hudEditMode.set(false);
        try { executeClient('hud.layout.close'); } catch (e) { }
    };

    // демо-показ блоков, которые в обычной игре появляются лишь на секунды
    const demo = (what) => { try { executeClient('hud.layout.demo', what); } catch (e) { } };

    // ── перетаскивание самой панели (за заголовок), место запоминаем
    let pos = null;             // {x, y} в пикселях; null = стандартное место слева
    let panel;
    try {
        const raw = window.localStorage && window.localStorage.getItem('hudedit.panel');
        if (raw) pos = JSON.parse(raw);
    } catch (e) { }

    $: panelStyle = pos ? `left:${pos.x}px;top:${pos.y}px;transform:none;` : '';

    let pdrag = null;
    const onPanelDown = (e) => {
        if (e.target && (e.target.tagName === 'BUTTON' || e.target.tagName === 'INPUT')) return;
        const r = panel.getBoundingClientRect();
        pdrag = { sx: e.clientX, sy: e.clientY, bx: r.left, by: r.top, w: r.width, h: r.height };
        window.addEventListener('mousemove', onPanelMove);
        window.addEventListener('mouseup', onPanelUp);
        e.preventDefault();
    };
    const onPanelMove = (e) => {
        if (!pdrag) return;
        const x = Math.max(0, Math.min(window.innerWidth - pdrag.w, pdrag.bx + e.clientX - pdrag.sx));
        const y = Math.max(0, Math.min(window.innerHeight - pdrag.h, pdrag.by + e.clientY - pdrag.sy));
        pos = { x: Math.round(x), y: Math.round(y) };
    };
    const onPanelUp = () => {
        pdrag = null;
        window.removeEventListener('mousemove', onPanelMove);
        window.removeEventListener('mouseup', onPanelUp);
        try { window.localStorage && window.localStorage.setItem('hudedit.panel', JSON.stringify(pos)); } catch (e) { }
    };
    const resetPanel = () => {
        pos = null;
        try { window.localStorage && window.localStorage.removeItem('hudedit.panel'); } catch (e) { }
    };
</script>

<svelte:window on:keydown={onKey} />

{#if $hudEditMode}
    <!-- направляющие: центр, трети, края -->
    {#if showGuides}
        <div class="he-guides">
            <i class="v" style="left:50%"></i>
            <i class="v t" style="left:33.333%"></i>
            <i class="v t" style="left:66.667%"></i>
            <i class="h" style="top:50%"></i>
            <i class="h t" style="top:33.333%"></i>
            <i class="h t" style="top:66.667%"></i>
            <!-- линейки по краям с делениями через 5% -->
            <div class="he-ruler top">
                {#each Array(21) as _, i}
                    <b class:big={i % 2 === 0} style="left:{i * 5}%">{#if i % 2 === 0}<u>{i * 5}</u>{/if}</b>
                {/each}
            </div>
            <div class="he-ruler left">
                {#each Array(21) as _, i}
                    <b class:big={i % 2 === 0} style="top:{i * 5}%">{#if i % 2 === 0}<u>{i * 5}</u>{/if}</b>
                {/each}
            </div>
        </div>
    {/if}

    <!-- панель редактора -->
    <div class="he-panel" bind:this={panel} style={panelStyle} role="presentation" on:mousedown|stopPropagation>
        <div class="he-hair"></div>
        <div class="he-head" role="presentation" on:mousedown={onPanelDown} title="Перетащите окно за заголовок">
            <div>
                <p class="he-kick">Редактор интерфейса <span class="he-move">⠿ можно перетащить</span></p>
                <h1 class="he-title">Расположение худа</h1>
            </div>
            <button class="he-x" on:click={close}>✕</button>
        </div>

        <div class="he-body">
            <div class="he-list">
                {#each HUD_PARTS as p}
                    <button class="he-item" class:on={sel === p.id} on:click={() => hudEditSelected.set(p.id)}>
                        <span class="he-dot" class:hid={$hudLayout[p.id] && $hudLayout[p.id].hidden}></span>
                        <span class="he-name">{p.name}</span>
                        <span
                            class="he-eye"
                            role="presentation"
                            on:click|stopPropagation={() => applyPatch(p.id, { hidden: !$hudLayout[p.id].hidden })}
                        >{$hudLayout[p.id] && $hudLayout[p.id].hidden ? '🚫' : '👁'}</span>
                    </button>
                {/each}
            </div>

            <div class="he-props">
                {#if part}
                    <div class="he-row">
                        <label>{part.pin === 'map' ? 'X, % карты' : 'X, %'}<input type="number" step="0.1" value={part.x}
                            on:input={(e) => applyPatch(sel, { x: num(e.target.value, 1) })} /></label>
                        <label>{part.pin === 'map' ? 'Y, % карты' : 'Y, %'}<input type="number" step="0.1" value={part.y}
                            on:input={(e) => applyPatch(sel, { y: num(e.target.value, 1) })} /></label>
                    </div>

                    <!-- РАЗМЕР блока: кнопки, ползунок и ручной ввод -->
                    <div class="he-size">
                        <span class="he-cap">Размер блока — {Math.round(part.s * 100)}%</span>
                        <div class="he-sizerow">
                            <button on:click={() => scaleBy(sel, -0.05)} title="Меньше">−</button>
                            <input class="he-range" type="range" min={SCALE_MIN} max={SCALE_MAX} step="0.05"
                                value={part.s}
                                on:input={(e) => applyPatch(sel, { s: clampScale(e.target.value) })} />
                            <button on:click={() => scaleBy(sel, 0.05)} title="Больше">+</button>
                            <input class="he-snum" type="number" step="0.05" min={SCALE_MIN} max={SCALE_MAX}
                                value={part.s}
                                on:input={(e) => applyPatch(sel, { s: clampScale(e.target.value) })} />
                            <button on:click={() => applyPatch(sel, { s: 1 })} title="Вернуть 100%">×1</button>
                        </div>
                        <span class="he-hint">Ещё проще: колесо мыши над блоком или золотой уголок в его углу</span>
                    </div>

                    <div class="he-row">
                        <label class="wide">Точка привязки
                            <select value={part.anchor} on:change={(e) => applyPatch(sel, { anchor: e.target.value })}>
                                {#each Object.keys(ANCHOR_NAME) as a}
                                    <option value={a}>{ANCHOR_NAME[a]}</option>
                                {/each}
                            </select>
                        </label>
                    </div>

                    <label class="he-pin">
                        <input type="checkbox" checked={part.pin === 'map'} on:change={(e) => togglePin(e.target.checked)} />
                        <span>Привязать к миникарте <i>блок поедет вместе с картой</i></span>
                    </label>

                    <div class="he-pad">
                        <span class="he-cap">Стрелками — по 0.1%, с Shift — по 1%, «+»/«−» — размер</span>
                        <div class="he-arrows">
                            <button on:click={() => nudge(0, -1, false)}>↑</button>
                            <div>
                                <button on:click={() => nudge(-1, 0, false)}>←</button>
                                <button on:click={() => nudge(1, 0, false)}>→</button>
                            </div>
                            <button on:click={() => nudge(0, 1, false)}>↓</button>
                        </div>
                    </div>

                    <div class="he-quick">
                        <span class="he-cap">Поставить в:</span>
                        <div class="he-grid9">
                            <button on:click={() => putTo('tl', 1.5, 2)}>┌</button>
                            <button on:click={() => putTo('tc', 50, 2)}>┬</button>
                            <button on:click={() => putTo('tr', 98.5, 2)}>┐</button>
                            <button on:click={() => putTo('lc', 1.5, 50)}>├</button>
                            <button on:click={() => putTo('cc', 50, 50)}>┼</button>
                            <button on:click={() => putTo('rc', 98.5, 50)}>┤</button>
                            <button on:click={() => putTo('bl', 1.5, 98)}>└</button>
                            <button on:click={() => putTo('bc', 50, 98)}>┴</button>
                            <button on:click={() => putTo('br', 98.5, 98)}>┘</button>
                        </div>
                    </div>

                    <div class="he-demo">
                        <span class="he-cap">Показать для примерки:</span>
                        <div class="he-demorow">
                            <button on:click={() => demo('notify')}>Уведомление</button>
                            <button on:click={() => demo('level')}>Поднятие уровня</button>
                            <button on:click={() => demo('announce')}>Объявление</button>
                            <button on:click={() => demo('gangwar')}>Забив</button>
                            <button on:click={() => demo('vehicle')}>Спидометр</button>
                        </div>
                    </div>
                {/if}
            </div>
        </div>

        <div class="he-foot">
            <label class="he-check">
                <input type="checkbox" bind:checked={showGuides} /> направляющие и линейки
            </label>
            <div class="he-btns">
                <button class="he-btn ghost" on:click={reset}>Сбросить</button>
                <button class="he-btn ghost" on:click={resetPanel} title="Вернуть окно редактора на место">Окно</button>
                <button class="he-btn gold" on:click={save}>Применить всем</button>
            </div>
        </div>
        {#if saved}<div class="he-saved">{saved}</div>{/if}
    </div>
{/if}

<style>
    .he-guides { position: fixed; inset: 0; z-index: 88; pointer-events: none; }
    .he-guides i { position: absolute; background: rgba(231, 174, 63, 0.55); }
    .he-guides i.v { top: 0; bottom: 0; width: 1px; }
    .he-guides i.h { left: 0; right: 0; height: 1px; }
    .he-guides i.t { background: rgba(120, 190, 255, 0.28); }

    .he-ruler { position: absolute; background: rgba(8, 7, 6, 0.72); }
    .he-ruler.top { left: 0; right: 0; top: 0; height: 1.8vh; border-bottom: 1px solid rgba(231, 174, 63, 0.35); }
    .he-ruler.left { top: 0; bottom: 0; left: 0; width: 1.8vh; border-right: 1px solid rgba(231, 174, 63, 0.35); }
    .he-ruler b { position: absolute; background: rgba(231, 174, 63, 0.5); }
    .he-ruler.top b { top: 0; width: 1px; height: 0.5vh; }
    .he-ruler.top b.big { height: 1vh; }
    .he-ruler.left b { left: 0; height: 1px; width: 0.5vh; }
    .he-ruler.left b.big { width: 1vh; }
    .he-ruler u {
        position: absolute; text-decoration: none;
        font: 700 0.85vh 'Manrope', sans-serif; color: rgba(243, 234, 214, 0.65);
    }
    .he-ruler.top u { left: 0.25vh; top: 0.15vh; }
    .he-ruler.left u { left: 0.15vh; top: 0.15vh; }

    .he-panel {
        /* стандартное место — слева: почти весь худ стоит справа.
           Заголовком окно перетаскивается куда угодно (место запоминается). */
        position: fixed; z-index: 95; left: 3vh; top: 50%; transform: translateY(-50%);
        width: 34vh; box-sizing: border-box; padding: 1.8vh 1.6vh 1.4vh;
        border-radius: 1.6vh; overflow: hidden;
        background: rgba(16, 13, 11, 0.97); border: 1px solid rgba(224, 168, 62, 0.42);
        box-shadow: 0 2.2vh 5.6vh rgba(0, 0, 0, 0.62);
        font-family: 'Manrope', 'Gilroy', sans-serif; color: #f3ead6;
        pointer-events: auto;
    }
    .he-hair { position: absolute; top: 0; left: 1.6vh; right: 1.6vh; height: 1px;
        background: linear-gradient(90deg, transparent, rgba(231, 174, 63, 0.65), transparent); }
    .he-head { display: flex; align-items: flex-start; justify-content: space-between; margin-bottom: 1.3vh;
        cursor: move; user-select: none; }
    .he-kick { margin: 0 0 0.3vh; font-size: 0.9vh; font-weight: 700; letter-spacing: 0.18em;
        text-transform: uppercase; color: #e7ae3f; }
    .he-move { margin-left: 0.5vh; letter-spacing: 0.06em; color: rgba(243, 234, 214, 0.35); }
    .he-title { margin: 0; font-size: 1.75vh; font-weight: 800; color: #fff; }
    .he-x { cursor: pointer; border: none; background: transparent; color: rgba(243, 234, 214, 0.5);
        font-size: 1.5vh; font-weight: 700; line-height: 1; }
    .he-x:hover { color: #f3ead6; }

    .he-body { display: flex; flex-direction: column; gap: 1.2vh; }
    .he-list { display: flex; flex-direction: column; gap: 0.35vh; max-height: 26vh; overflow-y: auto; }
    .he-item { display: flex; align-items: center; gap: 0.7vh; cursor: pointer; text-align: left;
        border: 1px solid transparent; background: rgba(255, 255, 255, 0.03); color: rgba(243, 234, 214, 0.8);
        border-radius: 0.7vh; padding: 0.55vh 0.7vh; font: 600 1.1vh 'Manrope', sans-serif; }
    .he-item:hover { background: rgba(255, 255, 255, 0.07); }
    .he-item.on { border-color: #e0a83e; background: rgba(48, 38, 22, 0.95); color: #fff; }
    .he-dot { width: 0.6vh; height: 0.6vh; border-radius: 50%; background: #e7ae3f; flex-shrink: 0; }
    .he-dot.hid { background: rgba(255, 255, 255, 0.25); }
    .he-name { flex: 1; min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
    .he-eye { cursor: pointer; font-size: 1.1vh; opacity: 0.75; }
    .he-eye:hover { opacity: 1; }

    .he-props { display: flex; flex-direction: column; gap: 1vh; }
    .he-row { display: flex; gap: 0.7vh; }
    .he-row label { flex: 1; display: flex; flex-direction: column; gap: 0.3vh;
        font: 600 0.95vh 'Manrope', sans-serif; color: rgba(243, 234, 214, 0.55);
        letter-spacing: 0.06em; text-transform: uppercase; }
    .he-row label.wide { flex: 1 1 100%; }
    .he-row input, .he-row select {
        box-sizing: border-box; width: 100%; background: rgba(12, 10, 8, 0.95);
        border: 1px solid rgba(224, 168, 62, 0.3); border-radius: 0.6vh; color: #f3ead6;
        padding: 0.55vh 0.6vh; font: 700 1.15vh 'Manrope', sans-serif; outline: none;
    }
    .he-row input:focus, .he-row select:focus { border-color: #e0a83e; }

    .he-sizerow { display: flex; align-items: center; gap: 0.4vh; }
    .he-sizerow button {
        flex-shrink: 0; width: 2.4vh; height: 2.4vh; cursor: pointer;
        border: 1px solid rgba(224, 168, 62, 0.28); background: rgba(28, 22, 15, 0.95);
        color: #f3ead6; border-radius: 0.6vh; font: 700 1.2vh 'Manrope', sans-serif;
    }
    .he-sizerow button:hover { border-color: #e0a83e; background: rgba(48, 38, 22, 0.98); }
    .he-range { flex: 1; min-width: 0; height: 2.4vh; accent-color: #e0a83e; cursor: pointer; }
    .he-snum {
        flex-shrink: 0; width: 5.2vh; box-sizing: border-box; background: rgba(12, 10, 8, 0.95);
        border: 1px solid rgba(224, 168, 62, 0.3); border-radius: 0.6vh; color: #f3ead6;
        padding: 0.45vh 0.4vh; font: 700 1.1vh 'Manrope', sans-serif; outline: none; text-align: center;
    }
    .he-pin { display: flex; align-items: center; gap: 0.6vh; cursor: pointer;
        padding: 0.6vh 0.7vh; border-radius: 0.7vh; background: rgba(255,255,255,0.03);
        border: 1px solid rgba(224,168,62,0.18);
        font: 700 1.05vh 'Manrope', sans-serif; color: rgba(243, 234, 214, 0.85); }
    .he-pin:hover { border-color: rgba(224,168,62,0.45); }
    .he-pin i { display: block; font: 600 0.85vh 'Manrope', sans-serif; font-style: normal;
        color: rgba(243, 234, 214, 0.4); }

    .he-hint { display: block; margin-top: 0.4vh; font: 600 0.85vh 'Manrope', sans-serif;
        color: rgba(243, 234, 214, 0.4); }

    .he-cap { display: block; margin-bottom: 0.45vh; font: 600 0.9vh 'Manrope', sans-serif;
        letter-spacing: 0.08em; text-transform: uppercase; color: rgba(243, 234, 214, 0.45); }
    .he-arrows { display: flex; flex-direction: column; align-items: center; gap: 0.35vh; }
    .he-arrows div { display: flex; gap: 0.35vh; }
    .he-arrows button, .he-grid9 button, .he-demorow button {
        cursor: pointer; border: 1px solid rgba(224, 168, 62, 0.28); background: rgba(28, 22, 15, 0.95);
        color: #f3ead6; border-radius: 0.6vh; font: 700 1.1vh 'Manrope', sans-serif;
    }
    .he-arrows button { width: 3vh; height: 2.4vh; }
    .he-arrows button:hover, .he-grid9 button:hover, .he-demorow button:hover {
        border-color: #e0a83e; background: rgba(48, 38, 22, 0.98); }
    .he-grid9 { display: grid; grid-template-columns: repeat(3, 1fr); gap: 0.35vh; }
    .he-grid9 button { height: 2.4vh; }
    .he-demorow { display: flex; flex-wrap: wrap; gap: 0.35vh; }
    .he-demorow button { padding: 0.5vh 0.8vh; font-size: 1vh; }

    .he-foot { margin-top: 1.3vh; padding-top: 1.1vh; border-top: 1px solid rgba(255, 255, 255, 0.08);
        display: flex; flex-direction: column; gap: 0.9vh; }
    .he-check { display: flex; align-items: center; gap: 0.5vh;
        font: 600 1vh 'Manrope', sans-serif; color: rgba(243, 234, 214, 0.6); cursor: pointer; }
    .he-btns { display: flex; gap: 0.6vh; }
    .he-btn { flex: 1; cursor: pointer; border: none; border-radius: 0.9vh; padding: 0.9vh 0.6vh;
        font: 800 1.15vh 'Manrope', sans-serif; }
    .he-btn.gold { background: linear-gradient(135deg, #f0c863, #c8852f); color: #241a06; }
    .he-btn.ghost { background: rgba(255, 255, 255, 0.06); color: rgba(243, 234, 214, 0.75);
        border: 1px solid rgba(255, 255, 255, 0.12); }
    .he-btn:hover { filter: brightness(1.08); }
    .he-saved { margin-top: 0.8vh; text-align: center; font: 700 1vh 'Manrope', sans-serif; color: #76cf8a; }
</style>
